import { Button, Icons, Icon, Division } from "@ir/ui";
import "./Sidebar.scss";
import { useCallback } from "react";

interface SidebarCollapsableHandlerProps {
  collapsedSidebar: boolean;
  onToggle: (collapsed: boolean) => void;
}

const SidebarCollapsableHandler = ({
  collapsedSidebar,
  onToggle,
}: SidebarCollapsableHandlerProps) => {
  const handleToggleSidebar = useCallback(() => {
    onToggle(!collapsedSidebar);
  }, [collapsedSidebar, onToggle]);
  return (
    <Division className="toggle-holder">
      <Button
        onPress={handleToggleSidebar}
        noStyle
        className="sidebar-toggle bg-white border-right-1 border-color-grey-25"
      >
        <Icon
          name={
            collapsedSidebar
              ? Icons.ChevronRightDouble
              : Icons.ChevronLeftDouble
          }
        />
      </Button>
    </Division>
  );
};

export default SidebarCollapsableHandler;
